<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  {{ data.message }}
</div>
<div mat-dialog-actions>
  <button class="confirmation-dialog-cancel-btn" (click)="decline()" color="primary" mat-raised-button>{{ data.btnCancelText }}</button>
  <button class="confirmation-dialog-ok-btn" (click)="accept()" color="warn" mat-raised-button>{{ data.btnOkText }}</button>
</div>
